let lastUrl = '';
let lastCleanedUrl = '';
const pattern = 'trk';

export const removeTrackingParams = (href: string): string => {
  const urlObj = new URL(href);
  const paramNames = Array.from(urlObj.searchParams.keys());

  paramNames.forEach(paramName => {
    if (paramName.startsWith(pattern)) {
      urlObj.searchParams.delete(paramName);
    }
  });

  return urlObj.toString();
};

export const getCleanLocationHref = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  const currentUrl = window.location.href;

  if (currentUrl === lastUrl) {
    return lastCleanedUrl;
  }

  lastUrl = currentUrl;
  lastCleanedUrl = removeTrackingParams(currentUrl);

  return lastCleanedUrl;
};
